module.exports = __webpack_public_path__ + "img/tipi.78e667e6.svg";